export enum NavItemsEnum {
  INVEST = 'Invest',
  MANAGE = 'Manage',
  FAQ = 'FAQ'
}